import styled, { css } from "styled-components";
import { Container } from "../../Container/Container";

export const FeaturedVideoContainer = styled(Container)``;

const sizeLookup = {
  normal: "960px",
  wide: "1440px",
  "full screen": "100%",
  small: "720px",
};

interface FeaturedLocalVideoContainerProps {
  isWide: boolean;
}

export const FeaturedLocalVideoContainer = styled(
  Container
)<FeaturedLocalVideoContainerProps>`
  width: 100%;
  display: flex;
  justify-content: center;

  ${({ fullWidth, isWide }) =>
    fullWidth &&
    !isWide &&
    css`
      padding-left: 0;
      padding-right: 0;
    `}
`;

interface LocalVideoProps {
  $size: "normal" | "wide" | "full screen" | "small";
  $shadows: boolean;
  $rounded: boolean;
}

export const LocalVideo = styled.video<LocalVideoProps>`
  width: 100%;
  max-width: ${({ $size }) => sizeLookup[$size] || "100%"};
  box-shadow: ${({ $shadows, theme }) =>
    $shadows ? theme.shadows.extraSmallNeumorphic : "none"};
  border-radius: ${({ $rounded }) => ($rounded ? "12px" : "0")};
`;
